import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const BASE_URL = "https://api-project360-insights.haqdarshak.com";

const AgeTable = ({ type, states }) => {

  const pid = useSelector((state) => state.user.projectId);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const fetchData = async () => {

      setLoading(true);

      let url = `${BASE_URL}/kpi/citizen/age-${type}/?pid=${pid}`;

      states?.forEach((s) => {
        url += `&State=${s.value}`;
      });

      const res = await fetch(url);
      const json = await res.json();

      setData(json);
      setLoading(false);
    };

    if (pid) fetchData();

  }, [pid, type, states]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin h-8 w-8 border-2 border-blue-500 rounded-full border-t-transparent"></div>
      </div>
    );
  }

  if (!data) return null;

  const ageGroups = [
    { key: "under_18", label: "<18" },
    { key: "18_to_25", label: "18-25" },
    { key: "26_to_45", label: "26-45" },
    { key: "46_to_60", label: "46-60" },
    { key: "over_60", label: ">60" }
  ];

  return (
    <div className="bg-white rounded-xl shadow border border-gray-100 mt-6">

      <div className="p-4 border-b">
        <h2 className="text-lg font-semibold">
          Age Distribution (Citizen Level)
        </h2>
      </div>

      <div className="p-4">

        <table className="min-w-full border border-gray-200 rounded-lg">

          <thead className="bg-gray-50">
            <tr>
              <th className="p-3 text-left border-r">Age Group</th>
              <th className="p-3 text-left border-r">Total</th>
              <th className="p-3 text-left border-r">Male</th>
              <th className="p-3 text-left border-r">Female</th>
              <th className="p-3 text-left border-r">Other</th>
              <th className="p-3 text-left">N/A</th>
            </tr>
          </thead>

          <tbody>
            {ageGroups.map((g) => {

              const item = data[g.key] || {};

              return (
                <tr key={g.key} className="border-t hover:bg-gray-50">

                  <td className="p-3 border-r">{g.label}</td>
                  <td className="p-3 border-r">{item.total || 0}</td>
                  <td className="p-3 border-r">{item.male || 0}</td>
                  <td className="p-3 border-r">{item.female || 0}</td>
                  <td className="p-3 border-r">{item.other || 0}</td>
                  <td className="p-3">{item.not_available || 0}</td>

                </tr>
              );
            })}
          </tbody>

        </table>

      </div>

    </div>
  );
};

export default AgeTable;
